import React, { useEffect, useState } from "react";
import Sidebar from "./sidebar";
import TopNavbar from "./navbar";
import { useDispatch, useSelector } from "react-redux";
import { useHttp } from "hooks/useHttp";
import {
  getRecentBrandSettings,
  createBrandSettings,
  updateBrandSettings,
  getBrandSettings,
} from "api/brands/brandSettings";
import { getStatuses } from "api/milestones/getMilestones";
import Select from "react-select";
import Loader from "components/Loader";
import addNotification from "helpers/notify";
import {
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBInput,
  MDBBox,
  MDBBtn,
  MDBBtnGroup,
  MDBModalFooter,
} from "mdbreact";
import EyeImg from "assets/images/icons/eye-fill.png";
import formatTime from "helpers/formatTime";
import numeral from "numeral";
import DefaultImage from "assets/images/user.png";
import BrandSettingsView from "./brandSettingsView";
import BrandSettingsBulkAssignModel from "./brandSettingsBulkAssignModel";
import { eventTrack } from "helpers/ga4Helper";
import BrandModal from "./addBrandModal"
import BrandSettingsForm from "./brandSettingsForm";
import { ALL_PERMISSIONS } from "constants/permissionsConstants";
import { Modal } from "antd";
import { RequestCard } from "./requestCard";
import { ClockCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { createFeatureRequest } from "api/featureRequests/createFeatureRequest";
import { setFeatureRequest } from "actions/user";
import { computeFinalPermissions } from 'helpers/finalPermissions';

const BrandSettings = () => {
  const dispatch = useDispatch();
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const brandsRedux = useSelector((s) => s.user.brands);
  const featureRequestRedux = useSelector((s) => s.user.featureRequest);
  const usersPermissionRedux = useSelector((s) => s.user.userPermission);
  const companyPermissionRedux = useSelector((s) => s.user.companyPermission);
  const allPermissionRedux = useSelector((s) => s.user.allPermission);
  const FinalPermissions = computeFinalPermissions({
    userInfo: userInfoRedux,
    allPermission: allPermissionRedux,
    companyPermission: companyPermissionRedux,
    userPermission: usersPermissionRedux,
  });

  const [recentBrandSettings, setRecenetBrandSettings] = useState(false);
  const [include2DElements, setInclude2DElements] = useState(false);
  const [includeMiscellaneous, setIncludeMiscellaneous] = useState(false);
  const [excludeEmptyGeometry, setExcludeEmptyGeometry] = useState(true);
  const [excludeElementsNotInView, setExcludeElementsNotInView] =
    useState(true);

  const [requestModal, setRequestModal] = useState(false);
  const [requestType, setRequestType] = useState("");
  const [requestLoading, setRequestLoading] = useState(false);

  const [milestones, setMilestones] = useState([]);
  const [selectedMilestone, setSelectedMilstone] = useState(null);
  const [openCreateBrand, setOpenCreateBrand] = useState(false);
  const [globalSettings, setGlobalSettings] = useState({
    autopost: '',
    language: '',
    postingType: '',
    postingTime: '',
    brandPostingInstructions: '',
    globalBrandMessageForAudience: '',
    brandThemePrimaryColor: '',
    brandThemeSecondaryColor: '',
    mainEmailSupervisor: '',
    listEmailSupervisors: [],
    socialAccounts: '',
    postingCadence: '',
    modelType: '',
  });
  const TABS = {
    GLOBAL: "GLOBAL",
    BRAND: "BRAND",
  };

  const [activeTab, setActiveTab] = useState(TABS.GLOBAL);

  const parentBrandOptions = brandsRedux?.map((i) => ({
    label: i.name,
    value: i._id,
  }));

  const handleSearch = (keyword) => {};

  const { id, company } = userInfoRedux;
  const [selectedBrand, setSelectedBrand] = useState(null);

  useEffect(() => {
    getRecentBrandSetting();
  }, []);

  const { loading, request: getRecentBrandSetting } = useHttp({
    requestCallback: () => getRecentBrandSettings(company),
    onLoad: async (response) => {
      if (response?._id) {
        setGlobalSettings(response);
      } else {
        addNotification('Your global settings not created, please create from here!', 'danger');
      }
    },
    onError: (res) => {
      console.log("Error**", res);
      addNotification(res?.msg ?? 'Something went wrong, please connect with support', 'danger');
    },
  });

  const requestAccess = async () => {
    try {
      setRequestLoading(true);
      const res = await createFeatureRequest(userInfoRedux.id, {
        companyId: userInfoRedux.company,
        permission: requestType,
        userId: userInfoRedux.id,
      });
      if (res) {
        setRequestLoading(false);
        dispatch(
          setFeatureRequest(res?.map((feature) => feature.requestedFeature))
        );
      }
    } catch (e) {
      setRequestLoading(false);
    }
  };

  const handle2DElementCheckbox = (value = false) => {
    setInclude2DElements(value);
  };

  const handleExcludeEmptyGeometry = (value = false) => {
    setExcludeEmptyGeometry(value);
  };

  const handleExcludeElementsNotInView = (value = false) => {
    setExcludeElementsNotInView(value);
  };

  const handleMiscellaneousElementCheckbox = (value = false) => {
    setIncludeMiscellaneous(value);
  };

  const { loading: loadingNew, request: createNewGlobalSetting } = useHttp({
    requestCallback: (data) => createBrandSettings(data),
    onLoad: (res) => {
      addNotification('Global Brand Settings Created!', 'success');
    },
    onError: (res) => {
      addNotification('Something went wrong, please connect with support!', 'danger');

      console.log("Error**", res);
    },
  });

  const { loading: updateLoading, request: updateGlobalSetting } = useHttp({
    requestCallback: (data) => updateBrandSettings(data),
    onLoad: (res) => {
      addNotification('Global Brand Settings Updated!', 'success');
      return res;
    },
    onError: (res) => {
      addNotification('Something went wrong, please connect with support!', 'danger');
      console.log("Error**", res);
    },
  });


  const { request: getMileStone } = useHttp({
    requestCallback: () => getStatuses(company),
    onLoad: (res) => {
      return res;
    },
    onError: (res) => {
      console.log("Error**", res);
    },
  });

  const hanldeBrandSettingApiRequest = () => {
    if (globalSettings._id) {
      updateGlobalSetting(globalSettings);
    } else {
      createBrandSettings(globalSettings);
    }
  };

  const usersRedux = useSelector((s) => s.user.users);
  const milestonesRedux = useSelector((s) => s.user.milestones);

  let usersObj =
    usersRedux &&
    usersRedux.reduce((acc, val) => ({ ...acc, [val._id]: val }), {});

  //-------------------------------------------------- brand export settings
  const [isOpen, setOpen] = useState(false);
  const [isOpenBrandSettings, setOpenBrandSettings] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("");
  const [brandToEdit, setBrandToEdit] = useState(null);

  const getBrandSettingsOfBrand = (item) => {
    setOpenBrandSettings(true);
    setHeaderTitle(item?.title);
    setBrandToEdit(item);
  };

  //----- brand export settings ends

  const [bulkEditBrand, setBulkEditBrand] = useState([]);
  const [openBulkEditModel, setBulkEditModel] = useState(false);

  const handleCheckboxChange = (item) => {
    if (bulkEditBrand.includes(item)) {
      // If yes, remove it
      setBulkEditBrand(
        bulkEditBrand.filter((selectedItem) => selectedItem !== item)
      );
    } else {
      // If no, add it
      setBulkEditBrand([...bulkEditBrand, item]);
    }
  };

  return (
    <>
      <div className="personal-area">
        <TopNavbar handleSearch={handleSearch} />

        <div className="content-bg p-2">
          <div className="container d-flex mt-1">
            <Sidebar />

            <div className="profile-content px-0 pt-0 position-relative">
              <div className="w-100 px-0">
                <div className="d-flex justify-content-between px-3 py-3 border-bottom">
                  <div className="d-flex align-items-center">
                    {isOpenBrandSettings ? (
                      <i
                        className="fa fa-arrow-left cursor-pointer"
                        onClick={() => setOpenBrandSettings(false)}
                      ></i>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M9.95401 2.21109C11.2876 1.93193 12.6807 1.92312 14.0449 2.20834C14.2219 3.36789 14.9048 4.43941 15.9997 5.07152C17.0945 5.70362 18.364 5.75933 19.4566 5.33279C20.3858 6.37167 21.0747 7.58252 21.4997 8.87701C20.5852 9.61007 19.9997 10.7365 19.9997 11.9997C19.9997 13.2637 20.5859 14.3907 21.5013 15.1237C21.29 15.7641 21.0104 16.3927 20.6599 16.9997C20.3094 17.6068 19.9049 18.1632 19.4559 18.6664C18.3634 18.2401 17.0943 18.296 15.9997 18.9279C14.9057 19.5595 14.223 20.6299 14.0453 21.7884C12.7118 22.0675 11.3187 22.0763 9.95443 21.7911C9.77748 20.6316 9.09451 19.56 7.99967 18.9279C6.90484 18.2958 5.63539 18.2401 4.54272 18.6667C3.61357 17.6278 2.92466 16.4169 2.49964 15.1224C3.41412 14.3894 3.99968 13.2629 3.99968 11.9997C3.99968 10.7358 3.41344 9.60876 2.49805 8.87573C2.70933 8.23531 2.98894 7.60678 3.33942 6.99972C3.68991 6.39266 4.09443 5.83625 4.54341 5.33306C5.63593 5.7593 6.90507 5.70349 7.99967 5.07152C9.09364 4.43991 9.7764 3.36959 9.95401 2.21109ZM11.9997 14.9997C13.6565 14.9997 14.9997 13.6566 14.9997 11.9997C14.9997 10.3429 13.6565 8.99972 11.9997 8.99972C10.3428 8.99972 8.99967 10.3429 8.99967 11.9997C8.99967 13.6566 10.3428 14.9997 11.9997 14.9997Z"
                          fill="black"
                        />
                      </svg>
                    )}
                    <span
                      className="font-weight-bold ml-3 cursor-pointer text-black"
                      onClick={() => setOpenBrandSettings(false)}
                    >
                      Brand Settings
                    </span>
                    {isOpenBrandSettings && (
                      <div className="d-flex">
                        <span className="mx-3">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="7"
                            height="10"
                            viewBox="0 0 7 10"
                            fill="none"
                          >
                            <path
                              d="M6.84102 8.825L3.02435 5L6.84102 1.175L5.66602 0L0.666016 5L5.66602 10L6.84102 8.825Z"
                              fill="#9E9E9E"
                            ></path>
                          </svg>
                        </span>
                        <span className="font-weight-bold">{headerTitle}</span>
                      </div>
                    )}
                  </div>
                  {activeTab === TABS.GLOBAL && (
                    <div
                      className="header-btn bg-bid text-white border-bid rounded-lg h6 ml-auto mb-0 cursor-pointer mr-1"
                      onClick={() => {
                        hanldeBrandSettingApiRequest();
                        eventTrack(
                          "Save-BrandSettings-Action",
                          "Save-BrandSettings",
                          userInfoRedux?.name,
                          "+1",
                          false,
                          "+1"
                        );
                      }}
                    >
                      <span className="f-14">
                        <i className="fa fa-save mr-2 "></i> Save
                      </span>
                    </div>
                  )}

                  {activeTab === TABS.BRAND && (
                    <div className="header-btn bg-bid text-white border-bid rounded-lg h6 ml-auto mb-0 cursor-pointer mr-1"
                    onClick={() => {
                      if (FinalPermissions?.includes(ALL_PERMISSIONS.BRAND_ADD)) {
                        setOpenCreateBrand(true);
                      } else {
                        setRequestType(ALL_PERMISSIONS.BRAND_ADD);
                        setRequestModal(true);
                      }
                    }}
                    >
                      <span className="f-13">
                        <i className="fa fa-plus mr-1 "></i> Add Brand
                      </span>
                    </div>
                  )}
                </div>

                {/* Model For Add Brand */}
                
                {/* key forces a FULL remount on brand switch so no field
                    values or AI suggestions leak from the previously edited brand. */}
                <BrandModal key={selectedBrand || 'new'} isOpen={openCreateBrand} toggle={() => {setOpenCreateBrand(false)}} setSelectedBrand={setSelectedBrand} brand={selectedBrand} />
                  
                {!isOpenBrandSettings && (
                  <div
                    className="btn-group btn-group-toggle toggle-group mt-3 w-75 mx-3 report-btn-group"
                    data-toggle="buttons"
                  >
                    <label
                      className={`${"btn btn-secondary py-3"} ${
                        activeTab === TABS.GLOBAL ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(TABS.GLOBAL)}
                    >
                      <input
                        type="radio"
                        name="options"
                        id="option1"
                        defaultChecked
                      />
                      Global Settings
                    </label>
                    <label
                      className={`${"btn btn-secondary py-3"} ${
                        activeTab === TABS.BRAND ? "active" : ""
                      }`}
                      onClick={() => setActiveTab(TABS.BRAND)}
                    >
                      <input type="radio" name="options" id="option2" />
                      Brand Settings
                    </label>
                  </div>
                )}

                {isOpenBrandSettings ? (
                  <BrandSettingsView
                    brandToEdit={brandToEdit}
                  />
                ) : activeTab === TABS.GLOBAL ? (
                  loading || loadingNew || updateLoading ? (
                    <Loader />
                  ) : (
                    <div className="p-3">
                     {/* <GlobalSettings /> */}
                     <BrandSettingsForm setGlobalSettings={setGlobalSettings} globalSettings={globalSettings} />
                    </div>
                  )
                ) : loading || loadingNew || updateLoading ? (
                  <Loader />
                ) : (
                  <div className="pt-3">
                    <div className="brand-table-div overflow-hidden rounded-0">
                      <table className="bid-table brand-list-view-table border-top-none">
                        <thead>
                          <tr>
                            <th className="pl-0"></th>
                            <th>Brand Name</th>
                            <th>No. of Posts</th>
                            <th>Favourite</th>
                            <th>Members</th>
                            <th>Creation date</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {brandsRedux?.map((item, key) => (
                            <tr key={key}>
                              <td className="pl-0">
                                <input
                                  type="checkbox"
                                  className="squared-checkbox"
                                  onChange={() => handleCheckboxChange(item)}
                                />
                              </td>
                              <td>{item?.name}</td>
                              <td>
                                {item?.posts?.length ?? "0"}
                              </td>
                              <td>
                                {
                                  item?.favourite ? "Yes" : "No"
                                }
                              </td>
                              <td>
                                {" "}
                                <div className="users-profile-list">
                                  {item?.users
                                    .slice(0, 4)
                                    ?.map((val, index) => (
                                      <img
                                        width={20}
                                        height={20}
                                        key={index}
                                        className="u-profile"
                                        src={
                                          usersObj &&
                                          usersObj[val]?.profilePhoto
                                        }
                                        onError={(e) =>
                                          (e.target.src = DefaultImage)
                                        }
                                        alt={`User ${index + 1}`}
                                        title={
                                          usersObj &&
                                          `${usersObj[val]?.name} ${usersObj[val]?.lastName}`
                                        }
                                      />
                                    ))}
                                  {item?.users.length > 4 && (
                                    <div className="u-profile">
                                      +{item?.users.length - 1}
                                    </div>
                                  )}
                                </div>
                              </td>
                              <td>{formatTime(item?.createdAt)}</td>
                              {/* edit button */}
                              <td>
                                <div
                                  onClick={() => {
                                    setSelectedBrand(item._id);
                                    setOpenCreateBrand(true);
                                    eventTrack(
                                      "View-Brand-Settings-Action",
                                      "View-Brand-Settings",
                                      userInfoRedux?.name,
                                      "+1",
                                      false,
                                      "+1"
                                    );
                                  }}
                                  className="cursor-pointer"
                                >
                                  <img
                                    src={EyeImg}
                                    alt="eye"
                                    className="action-icon"
                                  />

                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        title={
          userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
        }
        open={requestModal}
        footer={null}
        onCancel={() => setRequestModal(false)}
      >
        <RequestCard
          status={featureRequestRedux?.includes(requestType)}
          loading={requestLoading}
          icon={
            featureRequestRedux?.includes(requestType) ? (
              <ClockCircleOutlined style={{ color: "black" }} />
            ) : (
              <InfoCircleOutlined style={{ color: "black" }} />
            )
          }
          title={
            featureRequestRedux?.includes(requestType)
              ? `Request Already Sent`
              : `Oops, looks like you need to ${
                  userInfoRedux?.companyAdmin
                    ? `Acquire License`
                    : `Request Access`
                }`
          }
          description={
            featureRequestRedux?.includes(requestType)
              ? `Please reach out to your brand Admin`
              : `Elevate your experience with exclusive futures, early releases, and premium features.`
          }
          buttonText={
            userInfoRedux?.companyAdmin ? "Acquire License" : "Request Access"
          }
          buttonHandler={() => requestAccess()}
        />
      </Modal>

      <BrandSettingsBulkAssignModel
        isOpen={openBulkEditModel}
        toggle={() => setBulkEditModel(false)}
        bulkEditBrand={bulkEditBrand}
        recentBrandSettings={recentBrandSettings}
      />
    </>
  );
};

export default BrandSettings;
